import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { BoxGroup } from '../models/box-group';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class BoxGroupsService extends CrudService implements AdvancedService<BoxGroup> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<BoxGroup>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/BoxGroups`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<BoxGroup>(BoxGroup, x);

                return res;
            })
        );
    }

    ListForOrganization(
        context: Context,
        filters: FilterInfos[],
        generalFilters: FilterInfos[],
        sortInfos: SortInfos,
        pageNumber = 0,
        pageSize = 100
    ): Observable<Results<BoxGroup>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Organizations/${this.organizationId}/BoxGroups`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<BoxGroup>(BoxGroup, x);

                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/BoxGroups/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(boxGroupId: string, boxGroup: BoxGroup): Observable<BoxGroup> {
        // Appel de la Web Api
        return this.http
            .put<BoxGroup>(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/BoxGroups/${boxGroupId}`, boxGroup, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    return x;
                })
            );
    }

    delete(boxGroupId: string): Observable<boolean> {
        // Appel de la Web Api
        return this.http
            .delete<BoxGroup>(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/BoxGroups/${boxGroupId}`, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    return true;
                })
            );
    }

    add(boxGroup: BoxGroup): Observable<BoxGroup> {
        // Appel de la Web Api
        return this.http.post<BoxGroup>(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/BoxGroups`, boxGroup, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    get(boxGroupId: string): Observable<BoxGroup> {
        // Appel de la Web Api
        return this.http.get<BoxGroup>(this.baseUrl + `/api/Organizations/${this.organizationId}/views/${this.viewId}/BoxGroups/${boxGroupId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    applyOrderChanges(boxGroups: BoxGroup[]) {
        // Appel de la Web Api
        return this.http
            .patch<BoxGroup[]>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/boxgroups/`, boxGroups, this.getDefaultHttpOptions())
            .pipe(map((x) => {}));
    }
}
